// src/services/holidayService.js

// Algoritmo para calcular a data da Páscoa (O ponto de partida para feriados móveis)
const getEasterDate = (year) => {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;

  return new Date(year, month - 1, day);
};

// Função auxiliar para somar/subtrair dias
const addDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export const getHolidays = (year) => {
  const easter = getEasterDate(year);
  // Carnaval: 47 dias antes da Páscoa
  const carnival = addDays(easter, -47);
  // Sexta-feira Santa: 2 dias antes da Páscoa
  const goodFriday = addDays(easter, -2);
  // Corpus Christi: 60 dias após a Páscoa
  const corpusChristi = addDays(easter, 60);

  const holidays = [
    // --- Feriados Nacionais Fixos ---
    { date: `${year}-01-01`, name: "Confraternização Universal" },
    { date: `${year}-04-21`, name: "Tiradentes" },
    { date: `${year}-05-01`, name: "Dia do Trabalho" },
    { date: `${year}-09-07`, name: "Independência do Brasil" },
    { date: `${year}-10-12`, name: "Nossa Senhora Aparecida" },
    { date: `${year}-11-02`, name: "Finados" },
    { date: `${year}-11-15`, name: "Proclamação da República" },
    { date: `${year}-11-20`, name: "Dia da Consciência Negra" },
    { date: `${year}-12-25`, name: "Natal" },

    // --- Feriados Nacionais Móveis ---
    { date: carnival.toISOString().split("T")[0], name: "Carnaval" },
    { date: goodFriday.toISOString().split("T")[0], name: "Sexta-feira Santa" },
    { date: easter.toISOString().split("T")[0], name: "Páscoa" },
    { date: corpusChristi.toISOString().split("T")[0], name: "Corpus Christi" },

    // --- Feriados Específicos de Sergipe / Nordeste ---
    { date: `${year}-06-24`, name: "São João" }, // Tradicionalmente fortíssimo no Nordeste
    { date: `${year}-12-08`, name: "Nossa Senhora da Conceição" }, // Feriado Estadual
  ];

  return holidays;
};

/**
 * Verifica se uma data é feriado.
 * Retorna o NOME do feriado se for, ou null se não for.
 */
export const checkHoliday = (dateObj) => {
  if (!dateObj) return null;

  const year = dateObj.getFullYear();
  // Garante o formato YYYY-MM-DD
  const dateString = dateObj.toISOString().split("T")[0];

  const holidays = getHolidays(year);
  const holiday = holidays.find((h) => h.date === dateString);

  return holiday ? holiday.name : null;
};
